import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import MicrowaveIcon from "@mui/icons-material/Microwave";
import BedIcon from "@mui/icons-material/Bed";
import KitchenOutlinedIcon from "@mui/icons-material/KitchenOutlined";
import CoffeeIcon from "@mui/icons-material/Coffee";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import ElectricKettleIcon from "@mui/icons-material/Coffee";
import ToasterIcon from "@mui/icons-material/Kitchen";
import DryIcon from "@mui/icons-material/Dry";
import OutdoorGrillIcon from "@mui/icons-material/OutdoorGrill";
import FireplaceIcon from "@mui/icons-material/Fireplace";
import KitchenIcon from "@mui/icons-material/Kitchen";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import WifiIcon from "@mui/icons-material/Wifi";
import TvIcon from "@mui/icons-material/Tv";

const servicios = [
  { name: "Cocina equipada", icon: <KitchenIcon /> },
  { name: "WiFi Starlink", icon: <WifiIcon /> },
  { name: "Aire acondicionado frío/calor", icon: <AcUnitIcon /> },
  { name: 'Televisión Android TV 32"', icon: <TvIcon /> },
  { name: "Heladera con freezer", icon: <KitchenOutlinedIcon /> },
  { name: "Ropa blanca", icon: <BedIcon /> },
  { name: "Pava eléctrica", icon: <ElectricKettleIcon /> },
  { name: "Tostadora eléctrica", icon: <ToasterIcon /> },
  { name: "Microondas", icon: <MicrowaveIcon /> },
  { name: "Cafetera Nespresso", icon: <CoffeeIcon /> },
  { name: "Estación de infusiones", icon: <LocalCafeIcon /> },
  { name: "Salamandra", icon: <FireplaceIcon /> },
  { name: "Fogonero/Brasero con parrilla ÑUKE", icon: <OutdoorGrillIcon /> },
  { name: "Secador de pelo", icon: <DryIcon /> },
  { name: "Bazar completo", icon: <RestaurantIcon /> },
];

export default servicios;
